import classnames from 'classnames';

import { useImagePriority } from '@/dreamComponentProvider/hooks';
import { rewriteImageSrc } from '@/utils/rewriteImageSrc';

import type { AuthorImagesElementProps } from './AuthorImages.types';

export function AuthorImagesElement(props: AuthorImagesElementProps) {
  const { element, children, attributes, className } = props;
  const { size, fill, authors } = element.attrs || {};

  const { fetchPriority, loading } = useImagePriority();

  return (
    <div className={classnames(className, 'relative')} {...attributes}>
      <div className="flex -space-x-1.5">
        {authors
          ?.map((author) => ({
            id: author.id,
            name: author.name,
            imgSrc: rewriteImageSrc(author?.profile_picture?.url, {
              format: 'auto',
              width: '256',
              fit: 'scale-down',
              onerror: 'redirect',
            }),
          }))
          .map(({ id, name, imgSrc }) => {
            return (
              <div
                key={id}
                className={classnames('rounded-full overflow-hidden')}
                style={{
                  width: size,
                  height: size,
                  border: '1px solid',
                  borderColor: fill,
                }}
              >
                <img
                  className={classnames('block object-cover rounded-full')}
                  src={imgSrc}
                  alt={name}
                  fetchPriority={fetchPriority}
                  loading={loading}
                  style={{
                    width: size,
                    height: size,
                  }}
                />
              </div>
            );
          })}
      </div>
      {children}
    </div>
  );
}
